import React from 'react';
import TuitionForm from './TuitionForm';
import SidePanel from './SidePanel';

const TuitionCalculator = () => {
    return (
        <>
            <div className="min-vh-100">
                <div className="container-fluid p-4">
                    <TuitionForm />
                </div>
            </div>
            <SidePanel />
        </>
    );
};

export default TuitionCalculator;